import AlertHistoryDetailPage from "./AlertHistoryDetailPage";

export default AlertHistoryDetailPage;
